import angular, {
  ICompileService,
  IComponentOptions,
  IDirective,
  ITemplateLinkingFunction,
} from "angular";
import {
  vsServiceName as PartTransactionDetailComponentServiceName,
  PartTransactionDetailComponentService,
} from "./service";
import { kebabCase } from "lodash";

export const vsDirectiveName = "partTransactionDetail";

partTransactionDetailDirective.$inject = [
  PartTransactionDetailComponentServiceName,
  "$compile",
];
export function partTransactionDetailDirective(
  partTransactionDetailComponentService: PartTransactionDetailComponentService,
  $compile: ICompileService
): IDirective {
  const compiledDetailDirectives: { [type: string]: ITemplateLinkingFunction } =
    {};

  return {
    scope: {
      item: "<",
    },
    restrict: "E",
    link: {
      pre: (s, elem, attrs, ctrl, transclude) => {
        const scope: any = s;
        const item = scope.item;
        const type = item.TableName;
        const linkingFunction = getLinkingFunction(type);

        const newElement = linkingFunction(scope, (element, s0) => {
          const newScope = <any>s0;
          newScope.item = item;
        });
        elem.append(newElement);
      },
    },
  };

  function getLinkingFunction(type: string) {
    const cachedElement = compiledDetailDirectives[type];
    if (cachedElement) {
      return cachedElement;
    }

    const registration =
      partTransactionDetailComponentService.getPartDetailComponentRegistration(
        type
      );

    if (!registration) {
      throw new Error(
        "Type not registered with partTransactionDetailComponentServiceProvider"
      );
    }

    const componentName = registration.componentName;
    const kebabCaseName = kebabCase(componentName);
    const itemElement = angular.element(
      `<${kebabCaseName}></${kebabCaseName}>`
    );
    itemElement.attr("item", "item");

    return (compiledDetailDirectives[componentName] = $compile(itemElement));
  }
}
